import Color from '../Color/Color'
import CopyToClipboard from '../CopyToClipboard/CopyToClipboard'
import FlashMessage from '../FlashMessage/FlashMessage'
import Tooltip from '../Tooltip/Tooltip'
import classes from './CopyToClipboardWithIcon.module.scss'
import { HiOutlineDuplicate } from 'react-icons/hi'
import { useState } from 'react'

export interface Props {
  value: string
  duration?: number
  variant?: 'hasBackgroundColor' | 'withoutBackgroundColor'
}

const renderText = (value: string) =>
  <Tooltip
    label={value}
  >
    <div className={classes.CopyText}>
      {value}
    </div>
  </Tooltip>

const renderCopied =
  <Color variant='green'>
    Copied
  </Color>

const renderCopyIcon =
  <div
    className={classes.CopyIcon}
    title='Click to copy to clipboard'
  >
    <HiOutlineDuplicate
      aria-hidden
      className={classes.CopyIcon}
      size={16}
    />
  </div>

const CopyToClipboardWithIcon = ({
  value,
  duration = 3000,
  variant = 'hasBackgroundColor'
}: Props) => {
  const [isCopied, setIsCopied] = useState(false)

  const CopyToClipboardWithIconClasses = [
    classes.CopyToClipboardWithIcon,
    classes[variant]
  ].filter(styleClass => styleClass).join(' ')

  const handleClickToCopy = () => {
    setIsCopied(true)
  }

  const handleFlashingEnd = () => {
    setIsCopied(false)
  }

  const isEnabled = window.location.protocol === 'https:'
  const hasNoBackgroundColor = variant === 'withoutBackgroundColor'

  if (isEnabled) {
    return (
      <CopyToClipboard
        hasBackgroundColor={!hasNoBackgroundColor}
        key={value}
        onClick={handleClickToCopy}
        textToCopy={value}
        title=''
      >
        <div className={CopyToClipboardWithIconClasses}>
          {renderText(value)}
          <FlashMessage
            duration={duration}
            flashMessage={renderCopied}
            isFlashing={isCopied}
            label={renderCopyIcon}
            onChange={handleFlashingEnd}
          />
        </div>
      </CopyToClipboard>
    )
  }

  return (
    <div className={CopyToClipboardWithIconClasses}>
      {renderText(value)}
    </div>
  )
}

export default CopyToClipboardWithIcon
